<template>
    <!--コンテンツ-->
    <main class="renew3_top">

        <!--メインバナー-->
        <div class="mv">
            <div class="renew3_wrapper mv_wrapper">
                <a href="/static/eprint" class="mv_link">
                    <img src="/static/renew3_img/top20250124.png" alt="コンビニ印刷" class="mv_img">
                </a>
            </div>
        </div>

        <div class="news" v-if="noticeInfo">
            <div data-v-450fc904 class="renew3_wrapper">
                <p class="news_text">お知らせ｜<a :href="noticeInfo.linkurl" target="_blank"
                        v-if="noticeInfo.linktarget == '1'" class="news_link">{{
                            noticeInfo.contexts }}</a><a :href="noticeInfo.linkurl" v-else class="news_link">{{
                            noticeInfo.contexts }}</a></p>
            </div>
        </div>

        <!--テンプレート選択-->
        <div class="format">
            <div class="renew3_wrapper format_wrapper">

                <!--テンプレートブロック-->
                <div id="rirekisyo-index" class="format_block format_block1">
                    <!--<h3 class="format_block_h3"></h3>-->

                    <div class="flex format_block_flex">
                        <a href="/format/rirekisho_job_change" id="toplnk_rirekisho_job_change" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change.png" alt="転職用の履歴書（JIS規格）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3 format_link_h3big">転職履歴書</h3>
                                <p class="format_link_txt">（JIS規格）</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/shokumukeirekisho" id="toplnk_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4／複数枚</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="職務経歴書" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1 format_link_bottom2">
                                <h3 class="format_link_h3 format_link_h3big">職務経歴書</h3>
                                <p class="format_link_txt">編年体式(時系列)</p>
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_job_new" id="toplnk_rirekisho_job_new" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_new.png" alt="新卒履歴書"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">新卒履歴書</h3>
                                <p class="format_link_txt">職歴欄なしでアピール欄広め</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rerekisho_part_time" id="toplnk_rerekisho_part_time" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_part_time.png" alt="アルバイト用の履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">アルバイト履歴書</h3>
                                <p class="format_link_txt">勤務曜日・勤務期間記入可能</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/ai/interview_practice" id="toplnk_interview_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">

                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aiinterview_fortop.png" alt="AIと面接練習"
                                    class="format_link_img">
                            </div>

                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">AIヤギと面接</h3>
                                <p class="format_link_txt">気軽にチャットで何度でも練習可能</p>
                            </div>
                            <button class="format_btn format_btn3">模擬面接する</button>
                        </a>
                        <!--<a href="/ai/aptitude_practice" id="toplnk_aptitude_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">

                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aptitude_w_fortop.png" alt="言語・非言語問題"
                                    class="format_link_img">
                            </div>

                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">AIで適性検査対策</h3>
                                <p class="format_link_txt">チャット形式で回答、レポート付き</p>
                            </div>
                            <button class="format_btn format_btn3">問題を解いてみる</button>
                        </a>-->

                        <a href="/format/rirekisho_arbeit_debut" id="rirekisho_arbeit_debut" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/rirekisho_single.png" alt="アルバイトデビュー履歴書"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">アルバイトデビュー履歴書</h3>
                                <p class="format_link_txt">チャット形式で作成</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>

                        <a href="/format/rirekisho_hukugyo" id="toplnk_rirekisho_job_change" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change.png" alt="副業用の履歴書（JIS規格）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">副業履歴書</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_ai_career" id="toplnk_rirekisho_ai_career" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change_ai.png" alt="転職用のAI履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">転職AI履歴書</h3>
                                <p class="format_link_txt">JIS規格・AI機能強化</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_job_change2" id="toplnk_rirekisho_job_change2" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change2.png" alt="転職用の履歴書（職歴欄短め）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">職歴欄短め履歴書</h3>
                                <p class="format_link_txt">社会人経験少なめの方向け</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_job_change_old" id="toplnk_rirekisho_job_change_old"
                            class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change.png" alt="転職用の履歴書（旧 JIS規格）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">転職用の履歴書<br>（書き方・見本付き）</h3>
                                <!--<p class="format_link_txt">通勤時間や扶養者情報欄あり</p>-->
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_job_new_single" id="toplnk_rirekisho_job_new_single"
                            class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/rirekisho_single_new.png" alt="新卒用A4一枚で書ける履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">新卒1枚で書ける履歴書</h3>
                                <p class="format_link_txt">職歴欄なしでコンパクト</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/internship" id="toplnk_internship" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_new.png" alt="インターンシップ用の履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">インターンシップ履歴書</h3>
                                <p class="format_link_txt">職歴欄なしアピール欄広め</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_part_time2" id="toplnk_rirekisho_part_time2" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_part_time2.png" alt="パート（パートタイム）用の履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">パート履歴書</h3>
                                <p class="format_link_txt">勤務曜日・勤務期間記入可能</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_single" id="toplnk_rirekisho_single" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/rirekisho_single.png" alt="A4一枚で書ける履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">A4一枚で書ける履歴書</h3>
                                <p class="format_link_txt">コンパクトなレイアウト</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_nophoto_double" id="toplnk_rirekisho_nophoto_double"
                            class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_nophoto_double.jpg"
                                    alt="証明写真なしの履歴書（職歴欄長め）テンプレート" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">証明写真なしの履歴書（長）</h3>
                                <p class="format_link_txt">写真なし、経歴欄が長め</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_nophoto" id="toplnk_rirekisho_nophoto" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/rirekisho_nophoto.png" alt="証明写真なしの履歴書（職歴欄短め）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">証明写真なしの履歴書（短）</h3>
                                <p class="format_link_txt">写真なし、経歴欄が短め</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_design_001" id="toplnk_rirekisho_design_001" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/sample/rirekisho_design_001_01.jpg"
                                    alt="新デザイン履歴書(beta)テンプレート" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">新デザイン履歴書(beta)</h3>
                                <p class="format_link_txt">一味違うデザイン</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_design_002" id="toplnk_rirekisho_design_002" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/sample/rirekisho_design_002.png"
                                    alt="新デザイン履歴書(gamma)テンプレート" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">新デザイン履歴書(gamma)</h3>
                                <p class="format_link_txt">写真で印象付け</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="https://youtu.be/msDHsolpzQs?si=PhKW9Hn1zTVnA07j" target="_blank" id="yagi-youtube"
                            class="format_link youtube-card">

                            <div class="format_link_top format_link_top">
                                <p class="format_link_memo">YouTube</p>
                                <img src="/static/img/formats/sample/youtube02.jpg" alt="この動画を見る"
                                    class="format_link_img pc">
                                <img src="/static/img/formats/sample/youtube02-sp.jpg" alt="この動画を見る"
                                    class="format_link_img sp">
                            </div>

                            <button class="format_btn">この動画を見る</button>
                        </a>
                        <a class="format_link"></a>

                    </div>

                </div>

                <!--テンプレートブロック-->
                <div id="keirekisho-index" class="format_block format_block2">
                    <h3 class="format_block_h3 format_block_h3_2">職務経歴書</h3>
                    <p class="format_block_lead">※コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応</p>

                    <div class="flex format_block_flex">
                        <a href="/format/sales_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="営業職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">営業職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/service_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">販売・サービス職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/plan_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">企画職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/webdesign_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">Webデザイナーの職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/nurse_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">看護師の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/ai/interview_practice" id="toplnk_interview_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">

                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aiinterview_fortop.png" alt="AIと面接練習"
                                    class="format_link_img">
                            </div>

                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">AIヤギと面接</h3>
                            </div>
                            <button class="format_btn format_btn3">模擬面接する</button>
                        </a>
                        <a href="/format/marketing_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">マーケティング職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/engineer_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">SE・IT系技術職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/electric_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">電気・機械系技術職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/finance_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">経理の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/hr_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">人事の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/affairs_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">総務の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/office_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">一般事務職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/legal_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">法務の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/ir_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">広報IRの職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/research_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">リサーチ職の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/technology_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">メディカル・化学・食品開発系の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/pharmacist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">薬剤師の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/physical_therapist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">理学療法士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/occupational_therapist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">作業療法士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/speech_hearing_therapist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">言語聴覚療法士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/nutritionist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">栄養士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/construction_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">各種施工管理技士（現場監督）の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/driver_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">ドライバーの職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/nursing_care_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">介護職(介護福祉士)の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/dental_hygienist_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">歯科衛生士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/childminder_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">保育士の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/other_shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">一般的な職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/shokumukeirekisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="販売・サービス職の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/shokumukeirekisho_type_career" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="キャリア式の職務経歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom2">
                                <h3 class="format_link_h3">キャリア式の職務経歴書</h3>
                                <!--<p class="format_link_txt">（JIS規格）</p>-->
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a class="format_link"></a>
                    </div>
                </div>

                <!--テンプレートブロック-->
                <div id="other-index" class="format_block format_block3">
                    <h3 class="format_block_h3">そのほか</h3>

                    <div class="flex format_block_flex">

                        <a href="/recognition" id="toplnk_ocr" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">手書きも可</p>
                                <img src="/static/img/formats/sample/ocrimg.png" alt="自動入力OCR" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">お手持ちの履歴書をアップロードして自動入力できる</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">アップロードする</button>
                        </a>

                        <a href="/format/letter" id="toplnk_rirekisho_job_change" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/yagish_letter_img.jpeg" alt="送付状テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">送付状</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">この送付状をつくる</button>
                        </a>
                        <a href="/format/taishokutodoke" id="toplnk_taishokutodoke" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/yagish_taishokutodoke_img.jpeg" alt="退職願・退職届テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">退職願・退職届</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">この退職願をつくる</button>
                        </a>
                        <a href="/format/shiboudoukisho" id="toplnk_shiboudoukisho" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/shiboudoukisho.jpg" alt="志望動機書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">志望動機書</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">志望動機書をつくる</button>
                        </a>
                        <a href="/format/entrysheet" id="toplnk_entrysheet" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/entrysheet_img.png" alt="エントリーシートテンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">エントリーシート</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="pc format_btn format_btn3">エントリーシートをつくる</button>
                            <button class="sp format_btn format_btn3">このESをつくる</button>
                        </a>
                        <a href="/format/skillsheet_type" id="toplnk_skillsheet" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/sample/skillsheet.png" alt="スキルシート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">スキルシート</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">スキルシートをつくる</button>
                        </a>
                        <a href="/idphotoprint" id="toplnk_idphotoprint" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">L判シール</p>
                                <img src="/static/img/formats/sample/idphotoprint.png" alt="証明写真印刷"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">証明写真印刷</h3>
                            </div>
                            <button class="format_btn format_btn3">証明写真を印刷する</button>
                        </a>
                        <a href="/ai/interview_practice" id="toplnk_interview_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">
                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aiinterview_fortop.png" alt="AIと面接練習"
                                    class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">AIヤギと面接</h3>
                                <p class="format_link_txt">気軽にチャットで何度も</p>
                            </div>
                            <button class="format_btn format_btn3">模擬面接する</button>
                        </a>
                        <a href="https://portal.yagish.jp/know-how/convenience-store-print/"
                            id="toplnk_rirekisho_job_change" target="_blank" class="format_link">
                            <div class="format_link_top">
                                <img src="https://portal.yagish.jp/wp-content/uploads/2024/12/yagi-print.png"
                                    alt="コンビニ印刷" class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">履歴書をコンビニや家で印刷</h3>
                            </div><button class="format_btn format_btn3">記事を読む</button>
                        </a>
                        <a href="/yagidigram" id="yagidy" target="_blank" class="format_link">
                            <div class="format_link_top">
                                <img src="/static/img/servicelist/servicelist10.png" alt="コンビニ印刷"
                                    class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">ヤギディ診断</h3>
                                <p class="format_link_txt">役立つ性格診断</p>
                            </div><button class="format_btn format_btn3">診断してみる</button>
                        </a>
                        <a href="/ai/aptitude_practice" id="toplnk_aptitude_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">

                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aptitude_w_fortop.png" alt="言語・非言語問題"
                                    class="format_link_img">
                            </div>

                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">AIで適性検査対策</h3>
                                <p class="format_link_txt">チャット形式で回答</p>
                            </div>
                            <button class="format_btn format_btn3">問題を解いてみる</button>
                        </a>
                        <a class="format_link"></a>
                    </div>
                </div>

            </div>
        </div>

        <!--ヤギッシュのサービス-->
        <div class="service">
            <div class="renew3_wrapper service_wrapper">
                <h3 class="service_h3">ヤギッシュのサービス</h3>

                <div class="service_list" v-if="$globalVar.in_app_payments">

                    <div class="service_item">
                        <p class="service_item_title">履歴書をつくりながらできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service09.png" alt="AIに文章作成" class="service_img_item">
                            <img src="/static/renew2_img/service13.png" alt="証明写真風加工" class="service_img_item">
                            <img src="/static/renew2_img/service08.png" alt="フォント切り替え" class="service_img_item">
                            <img src="/static/renew2_img/service11.png" alt="専属エージェント" class="service_img_item">
                            <a href="/format/rirekisho_job_change" class="service_img_item service_img_item--edit">
                                <img src="/static/renew2_img/service00.png" alt="作成">
                            </a>
                        </div>
                    </div>

                    <div class="service_item">
                        <p class="service_item_title">履歴書をつくったらできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service01.png" alt="PDFで出力&amp;メール送信" class="service_img_item">
                            <img src="/static/renew2_img/service02.png" alt="コンビニ印刷" class="service_img_item">
                            <img src="/static/renew2_img/service03.png" alt="バックアップ＆復元" class="service_img_item">
                            <img src="/static/renew2_img/service04.png" alt="自動でブラウザ保存" class="service_img_item">
                        </div>
                    </div>

                    <div class="service_item">
                        <p class="service_item_title">履歴書が完成してからもできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service10.png" alt="AIと面接練習" class="service_img_item">
                            <img src="/static/renew2_img/service14.png" alt="AIと自己分析" class="service_img_item">
                            <img src="/static/renew2_img/service15.png" alt="AIで適性検査" class="service_img_item">
                            <img src="/static/renew2_img/service05.png" alt="履歴書送信サービス" class="service_img_item">
                            <img src="/static/renew2_img/service12.png" alt="オファーサービス" class="service_img_item">
                            <img src="/static/renew2_img/service06.png" alt="転職相談就職支援" class="service_img_item">
                        </div>
                    </div>

                </div>

                <div class="flex formatbtn_list">
                    <a href="/format/rirekisho_job_change" class="formatbtn_link formatbtn_link1">履歴書をつくる</a>
                    <a href="/format/shokumukeirekisho" class="formatbtn_link formatbtn_link2">経歴書をつくる</a>
                    <a href="/format/letter" class="formatbtn_link formatbtn_link3">送付状をつくる</a>
                </div>

                <!-- <div class="top_yagiprime_bnr" v-if="$globalVar.in_app_payments">
                    <a href="/yagiprimeinfo" target="_blank">
                        <img src="../../public/static/renew3_img/top_primebnr_pc.png" alt="ヤギプライム加入"
                            class="pc top_yagiprime_bnrimg">
                        <img src="../../public/static/renew3_img/top_primebnr_sp.png" alt="ヤギプライム加入"
                            class="sp top_yagiprime_bnrimg">
                    </a>
                </div> -->
            </div>
        </div>

        <!--お問い合わせ-->
        <div class="contact">
            <div class="renew3_wrapper contact_wrapper">
                <div class="flex contact_list">
                    <a href="https://www.yagish.jp/contact/" target="_blank" class="pc contact_link">
                        <span>パートナーについての</span><br>相談をする</a>
                    <a href="/contact" class="contact_link">
                        <span>履歴書作成についての</span><br>お問い合わせ</a>
                    <a href="https://www.yagish.jp/contact/" target="_blank" class="sp contact_link">
                        <span>パートナーについての</span><br>相談をする</a>
                </div>
            </div>
        </div>

        <!--バナー-->

        <floating-button />

    </main>
</template>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

/*共通*/
.renew3_top .renew3_wrapper {
    width: 768px;
    margin: 0 auto;
    padding: 0 10px;
}

/*MV*/
.renew3_top .mv {
    margin-bottom: 20px;
}

.renew3_top .mv_img {
    width: 768px;
    max-width: 100%;
    margin-top: 0px;
}

/*テンプレート選択*/
.renew3_top .format {
    margin-bottom: 50px;
}

.renew3_top .format_block {
    margin-bottom: 30px;
}

.renew3_top .format_block_h3 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 15px;
}

.renew3_top .format_block_h3_2 {
    margin-bottom: 0;
}

.renew3_top .format_block_lead {
    font-size: 14px;
    margin-bottom: 20px;
}

.renew3_top .format_block_flex {
    justify-content: space-between;
    flex-wrap: wrap;
}

.renew3_top .format_link {
    width: calc(100% / 3 - 15px);
    margin-top: 20px;
}

.renew3_top .format_link:nth-of-type(1),
.renew3_top .format_link:nth-of-type(2),
.renew3_top .format_link:nth-of-type(3) {
    margin-top: 0;
}

.renew3_top .format_link:nth-of-type(3n-1):nth-last-of-type(1) {
    margin-right: auto;
}

.renew3_top .format_link:hover {
    transform: scale(1.04);
    text-decoration: none;
    opacity: 1;
}

.renew3_top .format_link_top {
    position: relative;
    text-align: center;
    background: #eef5e8;
    border-radius: 5px 5px 0 0;
    height: 80px;
    overflow: hidden;
}

.renew3_top .format_link_top2 {
    background: #FEF5F1;
}

.renew3_top .youtube-card {

    .format_link_top {
        height: 150px;
        padding: 15px 10px;
        background: #FBEAED;

        @include max-width(sm) {
            height: 170px;
        }

        .format_link_memo {
            color: #E3165C;
            border: 1px solid #E3165C;
        }

        .format_link_img {
            width: 100%;
            padding-top: 0;
        }

        .sp {
            display: none;

            @include max-width(sm) {
                display: block;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .format_btn {
        background: #E3165C;
    }
}

.renew3_top .format_link_memo {
    position: absolute;
    display: inline-block;
    font-weight: bold;
    font-size: 10px;
    color: #e95b10;
    background: #ffffff;
    border: 1px solid #e95b10;
    padding: 0 10px;
    margin-right: 5px;
    border-radius: 25px;
    top: 5px;
    left: 5px;
}

.renew3_top .format_link_img {
    display: block;
    width: 90%;
    padding-top: 10px;
    margin: 0 auto;
}

.renew3_top .format_link_bottom {
    background: #eef5e8;
    padding: 10px;
    height: 70px;
}

.renew3_top .format_link_bottom2 {
    background: #FEF5F1;
}

.renew3_top .format_link_h3 {
    font-weight: bold;
    font-size: 16px;
    color: #004d40;
}

.renew3_top .format_link_txt {
    font-size: 12px;
}

.renew3_top .format_btn {
    width: 100%;
    padding: 10px;
    border: none;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: #0f9934;
    border-radius: 0 0 5px 5px;
}

.renew3_top .format_btn:hover {
    opacity: 1;
}

.renew3_top .format_btn2 {
    background: #e95b10;
}

.renew3_top .format_btn3 {
    background: #004d40;
}

/*サービス*/
.renew3_top .service {
    margin-bottom: 50px;
    background: #eef5e8;
    padding: 50px 0;
}

.renew3_top .service_h3 {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
}

.renew3_top .service_item {
    margin-bottom: 30px;
}

.renew3_top .service_item_title {
    position: relative;
    font-weight: bold;
    font-size: 16px;
    color: #E95B10;
    margin-bottom: 10px;
    padding-left: 10px;
}

.renew3_top .service_item_title::before {
    position: absolute;
    content: "";
    background: #E95B10;
    width: 5px;
    height: 25px;
    left: 0;
}

.renew3_top .service_img_list {
    justify-content: flex-start;
    flex-wrap: wrap;
}

.renew3_top .service_img_item {
    width: 100px;
    height: auto;
    margin-right: 8px;
}

.renew3_top .formatbtn_list {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.renew3_top .formatbtn_link {
    width: calc(100% / 3 - 5px);
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    padding: 8px 0;
    border: 3px solid #0f9934;
    border-radius: 50px;
    background: #0f9934;
}

.renew3_top .formatbtn_link:hover {
    transform: scale(1.03);
    text-decoration: none;
    opacity: 1;
}

.renew3_top .formatbtn_link2 {
    border: 3px solid #e95b10;
    background: #e95b10;
}

.renew3_top .formatbtn_link3 {
    border: 3px solid #004d40;
    background: #004d40;
}

.top_yagiprime_bnr {
    margin-top: 50px;
}

/*お問い合わせ*/
.renew3_top .contact {
    margin-bottom: 50px;
}

.renew3_top .contact_list {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.renew3_top .contact_link {
    width: calc(50% - 5px);
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.4;
    padding: 10px 0;
    border: 3px solid #0f9934;
    border-radius: 5px;
}

.renew3_top .contact_link:hover {
    background: #c7deb3;
    text-decoration: none;
    opacity: 1;
}

.renew3_top .contact_link span {
    font-size: 14px;
}

/*SP*/
@media screen and (max-width: 640px) {

    /*共通*/
    .renew3_top .renew3_wrapper {
        width: 100%;
    }

    /*フォーマット選択*/
    .renew3_top .format_link {
        width: calc(50% - 10px);
    }

    .renew3_top .format_link:nth-of-type(3) {
        margin-top: 20px;
    }

    .renew3_top .format_link_bottom1 {
        height: 90px;
    }

    .renew3_top .format_link_h3 {
        font-size: 14px;
    }

    .renew3_top .format_btn {
        font-size: 14px;
    }

    /*ヤギッシュのサービス*/
    .renew3_top .service_img_list {
        justify-content: space-between;
    }

    .renew3_top .service_item:last-child {
        margin-bottom: 50px;
    }

    .renew3_top .service_img_item {
        margin-top: 8px;
        width: calc(100% / 3 - 10px);
    }

    .renew3_top .service_img_item:nth-of-type(1),
    .renew3_top .service_img_item:nth-of-type(2),
    .renew3_top .service_img_item:nth-of-type(3) {
        margin-top: 0;
    }

    .renew3_top .service_img_item:nth-of-type(3n-1):nth-last-of-type(1) {
        margin-right: auto;
    }

    .service_img_item--edit {
        margin-top: 8px !important;
        margin-right: auto !important;
    }

    .renew3_top .formatbtn_link {
        width: 250px;
        margin: 0 auto 15px;
    }

    .renew3_top .formatbtn_link:last-child {
        margin-bottom: 0;
    }

    /*お問い合わせ*/
    .renew3_top .contact_link {
        width: 100%;
        margin-bottom: 15px;
    }

    .renew3_top .contact_link:last-child {
        margin-bottom: 0;
    }

    .renew3_top .format_link_h3big {
        font-size: 16px;
    }

}
</style>
<style scoped>
.renew3_top .news {
    margin-bottom: 20px;
}

.renew3_top .news_text {
    border: 1px solid #0F9934;
    border-radius: 10px;
    padding: 10px;
    font-size: 12px;
}
</style>
<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
import FloatingButton from '../components/yagiprime/FloatingButton.vue'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'

// const MessageInvoker = {
//     postMessage: function (message) {
//         console.error(`Message received: ${message}`)
//     }
// }
export default {
  props: {
    affId: {
      type: String
    },
    oemId: {
      type: String
    }
  },
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick,
    'floating-button': FloatingButton
  },
  data: function () {
    return {
      unLoginBanner: '/static/renew3_img/yagish_eprint20241114.png',
      unLoginBannerId: 'top_eprint_bnr',
      unLoginBannerLnk: '',
      oemList: ['kokudo-bl'],
      is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      topflag: '2',
      top_pattern: 'ptn1b',
      isWhat: true,
      isWho: false,
      selectedKind: '',
      selectedHash: '',
      mvBanner: 1,
      noticeInfo: null,
      isSpecial20240508: false,
      slickOptions: {
        centerMode: true,
        // centerPadding: '-20px',
        variableWidth: false,
        accessibility: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        asNavFor: '.slider-nav',
        speed: 400
      },
      slickNavOptions: {
        focusOnSelect: true,
        asNavFor: '.slider-for',
        variableWidth: false,
        slidesToShow: 5,
        centerPadding: '20px'
      },
      randomNumber: 0
    }
  },
  methods: {
    // prefetchEprintHelp() {
    //     if (this._eprintPrefetched) return
    //     this._eprintPrefetched = true
    //     import(/* webpackPrefetch: true */ '@/views/pages/EprintHelp')
    // },
    searchHash: function (_hash) {
      this.selectedHash = _hash
    },
    searchKind: function (_kind) {
      this.selectedKind = _kind
    },
    getLink: function (f_id) {
      if (f_id == 'line_yagibot') {
        return process.env.VUE_APP_YAGIBOT_URL // 'https://lin.ee/lQ9AmgT' // https://lin.ee/FniFZ1i
      } else if (f_id == 'y') {
        return 'https://portal.yagish.jp/know-how/mid-career_how-to-write/#index2'
      } else {
        return '/format/' + f_id + '?frm=' + this.top_pattern
      }
    },
    getTarget: function (f_id) {
      if (f_id == 'line_yagibot') {
        return '_blank'
      } else {
        return ''
      }
    },
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    },
    toggleButton: function () {
      if (this.isWhat) {
        this.isWhat = false
        this.isWho = true
      } else {
        this.isWhat = true
        this.isWho = false
      }
      this.selectedKind = ''
      this.selectedHash = ''
    },
    getSelectedHash: function (classname, val) {
      if (val == this.selectedHash) {
        return classname + ' select'
      } else {
        return classname
      }
    },
    getSelectedKind: function (classname, val) {
      if (val == this.selectedKind) {
        return classname + ' select'
      } else {
        return classname
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    forSearchHashs: function () {
      const _rtVal = []
      if (this.selectedHash) {
        for (const obj of this.$site.rirekishoFormatsIndex) {
          for (const _hash of obj.hashs) {
            if (_hash == this.selectedHash) {
              _rtVal.push(obj)
            }
          }
        }
        return _rtVal
      } else {
        return this.$site.rirekishoFormatsIndex
      }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }

    if (Math.floor(Math.random() * 2) == 0) {
      this.topflag = '1'
      this.top_pattern = 'ptn1a'
    } else {
      this.topflag = '2'
      this.top_pattern = 'ptn1b'
    }
    this.topflag = '4'
    this.top_pattern = 'ptn2b_list'
    if (this.$site.appFlag == 'b') {
      this.topflag = '3'
      this.top_pattern = 'app'
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)

    const nowdate = new Date()
    const date1 = new Date('2024/05/09 00:00:00')
    const date2 = new Date('2024/05/12 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isSpecial20240508 = true
    } else {
      this.isSpecial20240508 = false
    }
    if (Math.floor(Math.random() * 2) == 0 && false) {
      this.unLoginBanner = '/static/renew3_img/yagiprime_superegent20241114.png'
      this.unLoginBannerId = 'top_superagent_bnr'
      this.unLoginBannerLnk = '/yagiprime_superagent'
    }

    const app = this

    const formData = new FormData()
    this.$axios
      .post(this.$varuna.endPoints.getNoticeinformation, formData, { timeout: 60000 })
      .then(function (response) {
        console.error(response.data)
        for (const _key in response.data.notice_list) {
          app.noticeInfo = response.data.notice_list[_key]
          break
        }
      })
      .catch(function (error) {
      }).finally(function () {
      })
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  },
  beforeMount: function () {
    this.$globalVar.googleAdsTagCheck('', '')
    if (Math.floor(Math.random() * 2) == 0) {
      this.randomNumber = 0
    } else {
      this.randomNumber = 1
    }
    console.error(this.affId)
    if (this.affId) {
      console.error(this.affId)
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'localhost')
    }
    if (this.oemList.indexOf(this.oemId) >= 0) {
      console.error(this.oemId)
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'localhost')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'localhost')
    }
  }
}
</script>
